const collectionProductCarousel = class extends HTMLElement {
  constructor() {
    super()

    this.swiper = null
    this.prevEl = this.querySelector('[data-collection-product-carousel-prev]')
    this.nextEl = this.querySelector('[data-collection-product-carousel-next]')
  }

  connectedCallback () {
    const slider = this.querySelector('.swiper')
    if (!slider) { return }

    const options = {
      loop: true,
      slidesPerView: 2,
      spaceBetween: 16,
      draggable: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
      breakpoints: {
        768: {
          slidesPerView: 5,
          spaceBetween: 24
        }
      },
      ...(this.prevEl && this.nextEl && {
        navigation: {
          nextEl: this.nextEl,
          prevEl: this.prevEl
        }
      })
    }

    this.swiper = new Swiper(slider, options)
  }
}

if (typeof window.customElements.get('collection-product-carousel') === 'undefined') {
  window.customElements.define('collection-product-carousel', collectionProductCarousel)
}

